// RIEE Logo — basado en el logo oficial de la RIEE
// Forma: rectángulo redondeado, fondo marrón oscuro (#3B2A1A),
// ícono de tres libros con marcapáginas (líneas blancas), panel blanco con texto "RIEE" en serif.

interface RieeLogoProps {
  height?: number;
  className?: string;
}

export default function RieeLogo({ height = 40, className = "" }: RieeLogoProps) {
  // Proporción original: ~4:1 ancho/alto
  const w = height * 4;
  const h = height;
  const r = h * 0.18; // border-radius

  // Sección ícono (libros) ocupa ~25% del ancho
  const iconW = w * 0.25;
  // Panel texto ocupa el resto con margen
  const textPanelX = iconW + h * 0.08;
  const textPanelW = w - textPanelX - h * 0.08;
  const textPanelH = h * 0.76;
  const textPanelY = h * 0.12;
  const textPanelR = h * 0.1;

  return (
    <svg
      width={w}
      height={h}
      viewBox={`0 0 ${w} ${h}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="RIEE — Revista Internacional de Estudios en Educación"
      role="img"
    >
      {/* Fondo general: marrón oscuro */}
      <rect width={w} height={h} rx={r} fill="#3B2A1A" />

      {/* Panel blanco del texto */}
      <rect
        x={textPanelX}
        y={textPanelY}
        width={textPanelW}
        height={textPanelH}
        rx={textPanelR}
        fill="white"
      />

      {/* ——— ÍCONO: tres libros apilados + marcapáginas ——— */}
      {/* Calculamos el área del ícono centrada en la sección izquierda */}
      {(() => {
        const cx = iconW / 2;
        const cy = h / 2;
        const bW = iconW * 0.52;  // ancho de cada libro (lomo curvo)
        const bH = h * 0.115;     // alto de cada libro
        const bR = bH * 0.4;      // curvatura del lomo
        const gap = h * 0.055;    // separación entre libros
        const strokeW = h * 0.038;
        const sc = "white";

        // Los tres libros centrados verticalmente
        const topBookY = cy - bH - gap;      // libro superior
        const midBookY = cy - bH / 2;        // libro central
        const botBookY = cy + gap;           // libro inferior

        // Marcapáginas: cuelga del libro inferior
        const bmX = cx + bW * 0.15;
        const bmTop = botBookY + bH;
        const bmBot = bmTop + h * 0.18;
        const bmW = bW * 0.22;
        const bmHalfW = bmW / 2;

        return (
          <g>
            {/* Libro superior */}
            <rect x={cx - bW/2} y={topBookY} width={bW} height={bH} rx={bR}
              stroke={sc} strokeWidth={strokeW} fill="none" />
            {/* Libro central */}
            <rect x={cx - bW/2} y={midBookY} width={bW} height={bH} rx={bR}
              stroke={sc} strokeWidth={strokeW} fill="none" />
            {/* Libro inferior */}
            <rect x={cx - bW/2} y={botBookY} width={bW} height={bH} rx={bR}
              stroke={sc} strokeWidth={strokeW} fill="none" />
            {/* Marcapáginas (V invertida en la punta) */}
            <polyline
              points={`${bmX - bmHalfW},${bmTop} ${bmX - bmHalfW},${bmBot} ${bmX},${bmBot - h * 0.06} ${bmX + bmHalfW},${bmBot} ${bmX + bmHalfW},${bmTop}`}
              stroke={sc}
              strokeWidth={strokeW}
              fill="none"
              strokeLinejoin="round"
            />
          </g>
        );
      })()}

      {/* ——— TEXTO: "RIEE" en serif ——— */}
      <text
        x={textPanelX + textPanelW / 2}
        y={textPanelY + textPanelH * 0.72}
        textAnchor="middle"
        fontFamily="'EB Garamond', 'Georgia', 'Times New Roman', serif"
        fontWeight="600"
        fontSize={h * 0.5}
        fill="#3B2A1A"
        letterSpacing={h * 0.04}
      >
        RIEE
      </text>
    </svg>
  );
}
